export default __webpack_public_path__ + "static/media/aws.d6b27cac.png";